import { render, staticRenderFns } from "./newslist.vue?vue&type=template&id=20e4859b&scoped=true"
import script from "./newslist.vue?vue&type=script&lang=js"
export * from "./newslist.vue?vue&type=script&lang=js"
import style0 from "./newslist.vue?vue&type=style&index=0&id=20e4859b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e4859b",
  null
  
)

export default component.exports